import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

function validarForca(senha) {
  const regras = [
    { ok: senha.length >= 8, label: 'Mínimo 8 caracteres' },
    { ok: /[A-Z]/.test(senha), label: 'Uma letra maiúscula' },
    { ok: /[a-z]/.test(senha), label: 'Uma letra minúscula' },
    { ok: /[0-9]/.test(senha), label: 'Um número' },
    { ok: /[^A-Za-z0-9]/.test(senha), label: 'Um caractere especial' },
  ];
  return regras;
}

function RedefinirSenha() {
  const { token: tokenParam } = useParams();
  const navigate = useNavigate();
  const token = tokenParam || '';
  const [form, setForm] = useState({ nova_senha: '', confirmacao: '' });
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const regras = validarForca(form.nova_senha);
  const senhaValida = regras.every(r => r.ok);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');
    if (!senhaValida) { setErro('A senha não atende os requisitos mínimos.'); return; }
    if (form.nova_senha !== form.confirmacao) { setErro('As senhas não coincidem.'); return; }
    setCarregando(true);
    try {
      await api.post('/auth/resetar-senha', { token, ...form });
      setSucesso(true);
    } catch (err) {
      setErro(err.response?.data?.mensagem || 'Erro ao redefinir senha.');
    }
    setCarregando(false);
  }

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: '#1e40af', margin: 0 }}>CronoObra</h1>
          <p style={{ fontSize: 13, color: '#6b7280', marginTop: 6 }}>Redefinir senha</p>
        </div>

        {!token ? (
          <div style={{ textAlign: 'center', color: '#dc2626', fontSize: 14 }}>
            Link inválido. Solicite um novo link de recuperação.
            <br />
            <button className="btn-secondary" style={{ marginTop: 16 }} onClick={() => navigate('/esqueci-senha')}>
              Recuperar senha
            </button>
          </div>
        ) : sucesso ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
            <p style={{ fontSize: 14, color: '#374151' }}>Senha redefinida com sucesso!</p>
            <button
              className="btn-primary"
              style={{ marginTop: 20, width: '100%' }}
              onClick={() => navigate('/login')}
            >
              Ir para o login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
              Nova senha
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={form.nova_senha}
              onChange={e => setForm({ ...form, nova_senha: e.target.value })}
              style={{ marginBottom: 10 }}
              required
              autoFocus
            />

            {form.nova_senha && (
              <div style={{ marginBottom: 14, display: 'flex', flexDirection: 'column', gap: 4 }}>
                {regras.map(r => (
                  <span key={r.label} style={{ fontSize: 12, color: r.ok ? '#16a34a' : '#9ca3af' }}>
                    {r.ok ? '✓' : '○'} {r.label}
                  </span>
                ))}
              </div>
            )}

            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
              Confirmar senha
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={form.confirmacao}
              onChange={e => setForm({ ...form, confirmacao: e.target.value })}
              style={{ marginBottom: 12 }}
              required
            />

            {form.confirmacao && form.nova_senha !== form.confirmacao && (
              <p style={{ fontSize: 12, color: '#dc2626', marginBottom: 8, marginTop: -8 }}>As senhas não coincidem.</p>
            )}

            {erro && (
              <div style={{
                background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8,
                padding: '10px 14px', fontSize: 13, color: '#dc2626', marginBottom: 12,
              }}>
                {erro}
              </div>
            )}

            <button
              className="btn-primary"
              type="submit"
              disabled={carregando}
              style={{ width: '100%', padding: '12px', fontSize: 15 }}
            >
              {carregando ? 'Salvando...' : 'Redefinir senha'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default RedefinirSenha;
